import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type CardIdentifier } from "@kanpla/api-contract";

import { usersKeys } from "~/api/users/keys";

import { updateChildCardIdentifier } from "../request";

export function useUpdateChildCardIdentifier() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      tillId,
      childId,
      cardIdentifier
    }: {
      tillId: string;
      childId: string;
      cardIdentifier: CardIdentifier;
    }) => updateChildCardIdentifier(tillId, childId, cardIdentifier),
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: usersKeys.detail({
          childId: variables.childId,
          childHex: null
        })
      });
    }
  });
}
